import {
    parseTankersGroupType,
    TankersGroupType,
} from '_legacy/models/TankersGroupTypes';

const DATASET_SPECIALISED = 13;
const DATASET_DRY_CARGO = 14;
const DATASET_PCG = 16;
const DATASET_LPG_VLGC = 17;
const DATASET_LPG_MIDSIZE = 18;
const DATASET_LNG = 19;

const nonTankersDatasetIds = [
    DATASET_SPECIALISED,
    DATASET_DRY_CARGO,
    DATASET_PCG,
    DATASET_LPG_VLGC,
    DATASET_LPG_MIDSIZE,
    DATASET_LNG,
];

export interface RateUnit {
    id: number;
    value: string;
    label: string;
    shouldDisableAmount: boolean;
    shouldDisableBound: boolean;
    shouldDisableCurrency: boolean;
    shouldDisableDuration: boolean;
    unsupportedFixtureTypes: string[];
    unsupportedTankersGroupTypes: TankersGroupType[];
    unsupportedDatasets: number[];
}

const tankersRateTypeOrder: Record<TankersGroupType, string[]> = {
    [TankersGroupType.Period]: ['PD', 'WS', 'LS', 'RNR'],
    [TankersGroupType.Spot]: [
        'WS',
        'LS',
        'COA',
        'INDEX',
        'PD',
        'PMT',
        'RNR',
        'O/P',
    ],
};

export const rateUnits: RateUnit[] = [
    {
        id: 1,
        value: 'LS',
        label: 'LS',
        shouldDisableAmount: false,
        shouldDisableBound: false,
        shouldDisableCurrency: false,
        shouldDisableDuration: false,
        unsupportedFixtureTypes: [],
        unsupportedTankersGroupTypes: [],
        unsupportedDatasets: [],
    },
    {
        id: 2,
        value: 'PMT',
        label: 'PMT',
        shouldDisableAmount: false,
        shouldDisableBound: false,
        shouldDisableCurrency: false,
        shouldDisableDuration: false,
        unsupportedFixtureTypes: [],
        unsupportedTankersGroupTypes: [TankersGroupType.Period],
        unsupportedDatasets: [],
    },
    {
        id: 3,
        value: 'RNR',
        label: 'RNR',
        shouldDisableAmount: true,
        shouldDisableBound: true,
        shouldDisableCurrency: true,
        shouldDisableDuration: true,
        unsupportedFixtureTypes: [],
        unsupportedTankersGroupTypes: [],
        unsupportedDatasets: [],
    },
    {
        id: 4,
        value: 'PD',
        label: 'PD',
        shouldDisableAmount: false,
        shouldDisableBound: false,
        shouldDisableCurrency: false,
        shouldDisableDuration: false,
        unsupportedFixtureTypes: [],
        unsupportedTankersGroupTypes: [],
        unsupportedDatasets: [],
    },
    {
        id: 5,
        value: 'PDPR',
        label: 'PDPR',
        shouldDisableAmount: false,
        shouldDisableBound: false,
        shouldDisableCurrency: false,
        shouldDisableDuration: false,
        unsupportedFixtureTypes: [],
        unsupportedTankersGroupTypes: [
            TankersGroupType.Spot,
            TankersGroupType.Period,
        ],
        unsupportedDatasets: [],
    },
    {
        id: 6,
        value: 'O/P',
        label: 'O/P',
        shouldDisableAmount: true,
        shouldDisableBound: true,
        shouldDisableCurrency: true,
        shouldDisableDuration: true,
        unsupportedFixtureTypes: [],
        unsupportedTankersGroupTypes: [TankersGroupType.Period],
        unsupportedDatasets: [DATASET_PCG],
    },
    {
        id: 7,
        value: 'OTHER',
        label: 'OTHER',
        shouldDisableAmount: true,
        shouldDisableBound: true,
        shouldDisableCurrency: true,
        shouldDisableDuration: true,
        unsupportedFixtureTypes: [],
        unsupportedTankersGroupTypes: [
            TankersGroupType.Spot,
            TankersGroupType.Period,
        ],
        unsupportedDatasets: [],
    },
    {
        id: 8,
        value: 'WS',
        label: 'WS',
        shouldDisableAmount: false,
        shouldDisableBound: true,
        shouldDisableCurrency: true,
        shouldDisableDuration: false,
        unsupportedFixtureTypes: [],
        unsupportedTankersGroupTypes: [],
        unsupportedDatasets: [DATASET_PCG],
    },
    {
        id: 9,
        value: 'BB',
        label: 'BB',
        shouldDisableAmount: false,
        shouldDisableBound: false,
        shouldDisableCurrency: false,
        shouldDisableDuration: false,
        unsupportedFixtureTypes: ['COA', 'VOY', 'CVC', 'STTC'],
        unsupportedTankersGroupTypes: [
            TankersGroupType.Spot,
            TankersGroupType.Period,
        ],
        unsupportedDatasets: [],
    },
    {
        id: 10,
        value: 'PCM',
        label: 'PCM',
        shouldDisableAmount: false,
        shouldDisableBound: false,
        shouldDisableCurrency: false,
        shouldDisableDuration: false,
        unsupportedFixtureTypes: [],
        unsupportedTankersGroupTypes: [
            TankersGroupType.Spot,
            TankersGroupType.Period,
        ],
        unsupportedDatasets: [],
    },
    {
        id: 11,
        value: 'ETS',
        label: 'ETS',
        shouldDisableAmount: false,
        shouldDisableBound: false,
        shouldDisableCurrency: false,
        shouldDisableDuration: false,
        unsupportedFixtureTypes: [],
        unsupportedTankersGroupTypes: [
            TankersGroupType.Spot,
            TankersGroupType.Period,
        ],
        unsupportedDatasets: [],
    },
    {
        id: 12,
        value: 'FuelEU',
        label: 'FuelEU',
        shouldDisableAmount: false,
        shouldDisableBound: false,
        shouldDisableCurrency: false,
        shouldDisableDuration: false,
        unsupportedFixtureTypes: [],
        unsupportedTankersGroupTypes: [
            TankersGroupType.Spot,
            TankersGroupType.Period,
        ],
        unsupportedDatasets: [],
    },
    {
        id: 13,
        value: 'COA',
        label: 'COA',
        shouldDisableAmount: true,
        shouldDisableBound: true,
        shouldDisableCurrency: true,
        shouldDisableDuration: true,
        unsupportedFixtureTypes: [],
        unsupportedTankersGroupTypes: [TankersGroupType.Period],
        unsupportedDatasets: [...nonTankersDatasetIds],
    },
    {
        id: 14,
        value: 'INDEX',
        label: 'INDEX',
        shouldDisableAmount: true,
        shouldDisableBound: true,
        shouldDisableCurrency: true,
        shouldDisableDuration: true,
        unsupportedFixtureTypes: [],
        unsupportedTankersGroupTypes: [TankersGroupType.Period],
        unsupportedDatasets: [...nonTankersDatasetIds],
    },
];

export const rateNotReportedValue = 'RNR';
export const rateOpenValue = 'O/P';
export const coaValue = 'COA';
export const indexValue = 'INDEX';

export const getAvailableUnits = (
    type: string,
    tankersGroupType?: TankersGroupType,
    datasetId?: number
): RateUnit[] => {
    tankersGroupType = parseTankersGroupType(tankersGroupType);
    const filteredUnits = rateUnits.filter(
        (unit) =>
            isFixtureTypeSupported(unit, type) &&
            isTankersGroupTypeSupported(unit, tankersGroupType) &&
            isDatasetSupported(unit, datasetId)
    );

    if (
        tankersGroupType !== undefined &&
        tankersRateTypeOrder[tankersGroupType]
    ) {
        const order = tankersRateTypeOrder[tankersGroupType];
        return filteredUnits.sort((a, b) => {
            const indexA = order.indexOf(a.value);
            const indexB = order.indexOf(b.value);

            if (indexA !== -1 && indexB !== -1) {
                return indexA - indexB;
            }
            if (indexA !== -1) return -1;
            if (indexB !== -1) return 1;
            return 0;
        });
    }

    return filteredUnits;
};

const isFixtureTypeSupported = (unit: RateUnit, type: string): boolean => {
    return !unit.unsupportedFixtureTypes.includes(type);
};

const isTankersGroupTypeSupported = (
    unit: RateUnit,
    tankersGroupType?: TankersGroupType
): boolean => {
    return (
        tankersGroupType === undefined ||
        !unit.unsupportedTankersGroupTypes.includes(tankersGroupType)
    );
};

const isDatasetSupported = (unit: RateUnit, datasetId?: number): boolean => {
    return (
        datasetId === undefined || !unit.unsupportedDatasets.includes(datasetId)
    );
};

export interface RatePart {
    rateValue?: {
        flatRate?: {
            unit?: string;
        };
    };
}

export const isUnitSupportedForType = (
    unitValue: string | undefined,
    type: string,
    tankersGroupType?: TankersGroupType,
    datasetId?: number
) => {
    const unit = rateUnits.find((unit) => unit.value === unitValue);
    if (!unit) {
        return false;
    }

    if (type && unit.unsupportedFixtureTypes.includes(type)) {
        return false;
    }

    if (
        tankersGroupType !== undefined &&
        unit.unsupportedTankersGroupTypes.includes(tankersGroupType)
    ) {
        return false;
    }

    if (
        datasetId !== undefined &&
        unit.unsupportedDatasets.includes(datasetId)
    ) {
        return false;
    }

    return true;
};

export const isUnsupportedUnitForType = (
    ratePart: RatePart,
    type: string,
    tankersGroupType?: TankersGroupType,
    datasetId?: number
): boolean => {
    return !isUnitSupportedForType(
        ratePart.rateValue?.flatRate?.unit,
        type,
        tankersGroupType,
        datasetId
    );
};
